// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as Fetch from "bs-fetch/src/Fetch.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as Json_decode from "@glennsl/bs-json/src/Json_decode.bs.js";
import * as Json_encode from "@glennsl/bs-json/src/Json_encode.bs.js";
import * as Contract$Xuder from "./Contract.bs.js";

function toPayload(contract) {
  return Json_encode.object_(/* :: */[
              /* tuple */[
                "exEval",
                Json_encode.object_(/* :: */[
                      /* tuple */[
                        "tag",
                        "EvalContract"
                      ],
                      /* :: */[
                        /* tuple */[
                          "contents",
                          Contract$Xuder.Encode.contract(contract)
                        ],
                        /* [] */0
                      ]
                    ])
              ],
              /* :: */[
                /* tuple */[
                  "imageType",
                  "svg"
                ],
                /* [] */0
              ]
            ]);
}

function image(response) {
  return Json_decode.field("imgUrl", Json_decode.string, response);
}

var Decode = {
  image: image
};

var baseUrl = "https://danom.cahyanugraha12.me";

function drawImage(contract) {
  return fetch("https://danom.cahyanugraha12.me/contract-ex", Fetch.RequestInit.make(/* Post */2, undefined, Caml_option.some(JSON.stringify(toPayload(contract))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)(/* () */0)).then((function (prim) {
                  return prim.json();
                })).then((function (json) {
                return Promise.resolve(baseUrl + Json_decode.field("imgUrl", Json_decode.string, json));
              }));
}

export {
  toPayload ,
  Decode ,
  baseUrl ,
  drawImage ,
  
}
/* No side effect */
